var map = {
	"./1.svg": 5584,
	"./2.svg": 1683,
	"./3.svg": 2290,
	"./4.svg": 6221,
	"./arrow.svg": 7190,
	"./arrow1.svg": 8715,
	"./arrow2.svg": 3176,
	"./arrow3.svg": 5545,
	"./arrow4.svg": 8710,
	"./arrowLeft1.svg": 2990,
	"./arrowLeft2.svg": 7165,
	"./b1.svg": 3672,
	"./b2.svg": 1739,
	"./b3.svg": 4218,
	"./b4.svg": 1397,
	"./b4_1.svg": 6041,
	"./b4_2.svg": 1226,
	"./b5.svg": 4148,
	"./b6.svg": 8599,
	"./b6_1.svg": 4831,
	"./b6_2.svg": 2508,
	"./banner.svg": 8497,
	"./basket.svg": 8989,
	"./basketblack.svg": 3842,
	"./basketwhite.svg": 1288,
	"./bluefilter.svg": 2273,
	"./burger.svg": 1444,
	"./burgerblack.svg": 1333,
	"./call.svg": 6111,
	"./call1.svg": 3804,
	"./callwhite.svg": 4498,
	"./card.svg": 4817,
	"./check.svg": 2497,
	"./delete.svg": 930,
	"./download.svg": 1303,
	"./edit.svg": 975,
	"./email.svg": 1089,
	"./email1.svg": 9282,
	"./email2.svg": 9649,
	"./emial.svg": 4065,
	"./eye.svg": 4426,
	"./filter.svg": 7985,
	"./gmail.svg": 4811,
	"./graph.svg": 6929,
	"./hand.svg": 3708,
	"./heart.svg": 9733,
	"./heart1.svg": 6878,
	"./heart2.svg": 7597,
	"./heart3.svg": 5788,
	"./heartwhite.svg": 8304,
	"./image.svg": 3922,
	"./imageForInst.svg": 3483,
	"./img1.svg": 1257,
	"./instagram.svg": 5373,
	"./left.svg": 7644,
	"./list.svg": 71,
	"./logo.svg": 6962,
	"./logo1.svg": 9759,
	"./logoinst.svg": 9226,
	"./mail.svg": 9814,
	"./man.svg": 1009,
	"./map.svg": 9543,
	"./marker.svg": 2945,
	"./message.svg": 4520,
	"./message1.svg": 1161,
	"./minus.svg": 8441,
	"./minus1.svg": 122,
	"./mobileLogo.svg": 8548,
	"./nasos.svg": 8661,
	"./ok.svg": 1569,
	"./ok1.svg": 4978,
	"./out.svg": 8505,
	"./pay1.svg": 8852,
	"./pay2.svg": 6711,
	"./person.svg": 4388,
	"./personal.svg": 9411,
	"./photo1.svg": 4966,
	"./photo2.svg": 1189,
	"./photo3.svg": 3172,
	"./photo4.svg": 1531,
	"./plus.svg": 4491,
	"./plus1.svg": 4992,
	"./plus2.svg": 2083,
	"./pool.svg": 8133,
	"./product1.svg": 7857,
	"./product2.svg": 754,
	"./product3.svg": 8131,
	"./product4.svg": 1916,
	"./product5.svg": 9277,
	"./product6.svg": 9950,
	"./product7.svg": 943,
	"./product8.svg": 4376,
	"./profile.svg": 2030,
	"./prophileblack.svg": 9861,
	"./prophilewhite.svg": 8107,
	"./right.svg": 2387,
	"./schem.svg": 3813,
	"./search.svg": 4343,
	"./select.svg": 9539,
	"./select1.svg": 312,
	"./sliderimage.svg": 359,
	"./star.svg": 815,
	"./starblack.svg": 1012,
	"./swiper.svg": 1975,
	"./swiper1.svg": 5844,
	"./table.svg": 1145,
	"./visa.svg": 9468,
	"./visamini.svg": 5161,
	"./warn.svg": 6615,
	"./yes.svg": 2668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;